import { render, staticRenderFns } from "./applyFor.vue?vue&type=template&id=f2be0372&scoped=true"
import script from "./applyFor.vue?vue&type=script&lang=js"
export * from "./applyFor.vue?vue&type=script&lang=js"
import style0 from "./applyFor.vue?vue&type=style&index=0&id=f2be0372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_s74suowdwcam3het7yodnr4dnu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2be0372",
  null
  
)

export default component.exports